import { motion } from "framer-motion";

const pageVariants = {
  initial: {
    opacity: 0,
    y: 24,
    filter: "blur(8px)",
  },
  animate: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
  },
  exit: {
    opacity: 0,
    y: -18,
    filter: "blur(6px)",
  },
};

function PageTransition({ children, className }) {
  return (
    <motion.div
      className={`page-transition ${className}`}
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;
